<app-loader></app-loader>
<div>
	<app-notification-message></app-notification-message>
	<router-outlet></router-outlet>
</div>
